var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 28.4375H11.25C5.7375 28.4375 4.0625 26.7625 4.0625 21.25V8.75C4.0625 3.2375 5.7375 1.5625 11.25 1.5625H18.75C24.2625 1.5625 25.9375 3.2375 25.9375 8.75V21.25C25.9375 26.7625 24.2625 28.4375 18.75 28.4375ZM11.25 3.4375C6.775 3.4375 5.9375 4.2875 5.9375 8.75V21.25C5.9375 25.7125 6.775 26.5625 11.25 26.5625H18.75C23.225 26.5625 24.0625 25.7125 24.0625 21.25V8.75C24.0625 4.2875 23.225 3.4375 18.75 3.4375H11.25Z",
    fill: "#909090"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 7.8125H12.5C11.9875 7.8125 11.5625 7.3875 11.5625 6.875C11.5625 6.3625 11.9875 5.9375 12.5 5.9375H17.5C18.0125 5.9375 18.4375 6.3625 18.4375 6.875C18.4375 7.3875 18.0125 7.8125 17.5 7.8125Z",
    fill: "#909090"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 24.8252C13.4125 24.8252 12.125 23.5377 12.125 21.9502C12.125 20.3627 13.4125 19.0752 15 19.0752C16.5875 19.0752 17.875 20.3627 17.875 21.9502C17.875 23.5377 16.5875 24.8252 15 24.8252ZM15 20.9377C14.45 20.9377 14 21.3877 14 21.9377C14 22.4877 14.45 22.9377 15 22.9377C15.55 22.9377 16 22.4877 16 21.9377C16 21.3877 15.55 20.9377 15 20.9377Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileIcon);
export default __webpack_public_path__ + "static/media/mobileIcon.ac21dc11bdfb3495f053da5044e640c6.svg";
export { ForwardRef as ReactComponent };